import { nomenclatureConstants } from "../../constants";

const defaultState = {
  items: [],
  item: {},
  loadingItems: false,
  loadingItem: false,
  fetchedItems: false,
  fetchedItem: false,
  deleted: false,
  error: null
};

function normalData(arr) {
  if (!Array.isArray(arr)) return []

  return arr.map((elem, index) => Object.assign(elem, { index: (index + 1) }))
}

export const categoryReducer = function (state = defaultState, action) {
  switch (action.type) {
    case nomenclatureConstants.GETALL_REQUEST_CATEGORIES:
      return {
        ...state,
        item: {},
        loadingItems: true,
        loadingItem: false,
        fetchedItems: false,
        fetchedItem: false,
        error: null,
        deleted: false,
      };
    case nomenclatureConstants.GETALL_SUCCESS_CATEGORIES:
      return {
        ...state,
        items: normalData(action.response),
        loadingItems: false,
        fetchedItems: true,
      };
    case nomenclatureConstants.GETALL_FAILURE_CATEGORIES:
      return {
        ...state,
        loadingItems: false,
        fetchedItems: false,
        error: action.error,
      };

    case nomenclatureConstants.GETBYID_REQUEST_CATEGORIES:
      return {
        ...state,
        item: {},
        loadingItem: true,
        fetchedItem: false,
        error: null,
        deleted: false,
      };
    case nomenclatureConstants.GETBYID_SUCCESS_CATEGORIES:
      return {
        ...state,
        item: action.response,
        loadingItem: false,
        fetchedItem: true,
      };
    case nomenclatureConstants.GETBYID_FAILURE_CATEGORIES:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        error: action.error,
      };

    case nomenclatureConstants.CREATE_REQUEST_CATEGORIES:
      return {
        ...state,
        item: {},
        loadingItem: true,
        fetchedItem: false,
        error: null
      };
    case nomenclatureConstants.CREATE_SUCCESS_CATEGORIES:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: true,
        item: action.response,
        items: normalData(state.items.concat(action.response))
      };
    case nomenclatureConstants.CREATE_FAILURE_CATEGORIES:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        error: action.error,
      };

    case nomenclatureConstants.UPDATE_REQUEST_CATEGORIES:
      return {
        ...state,
        loadingItem: true,
        fetchedItem: false,
        error: null
      };
    case nomenclatureConstants.UPDATE_SUCCESS_CATEGORIES:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: true,
        item: action.response,
        items: normalData(state.items.map((elem) => {
          if (elem.id === action.response.id) return Object.assign(elem, { ...action.response })
          return elem
        }))
      };
    case nomenclatureConstants.UPDATE_FAILURE_CATEGORIES:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        error: action.error,
      };

    case nomenclatureConstants.ARCHIVE_REQUEST_CATEGORIES:
      return {
        ...state,
        loadingItem: true,
        fetchedItem: false,
        error: null,
      };
    case nomenclatureConstants.ARCHIVE_SUCCESS_CATEGORIES:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        items: normalData(state.items.map((elem) => {
          if (elem.id === action.id) return Object.assign(elem, { ...action.response, isArchive: !elem.isArchive })
          return elem
        }))
      };
    case nomenclatureConstants.ARCHIVE_FAILURE_CATEGORIES:
      return {
        ...state,
        loadingItem: false,
        error: action.error,
      };

    case nomenclatureConstants.DELETE_REQUEST_CATEGORIES:
      return {
        ...state,
        item: {},
        loadingItems: true,
        loadingItem: false,
        fetchedItems: false,
        fetchedItem: false,
        deleted: false,
        error: null
      };
    case nomenclatureConstants.DELETE_SUCCESS_CATEGORIES:
      return {
        ...state,
        loadingItems: false,
        fetchedItems: true,
        items: normalData(state.items.filter((elem) => elem.id !== action.id)),
        deleted: true,
      };
    case nomenclatureConstants.DELETE_FAILURE_CATEGORIES:
      return {
        ...state,
        loadingItems: false,
        fetchedItems: false,
        error: action.error,
        deleted: false,
      };

    case "RESET_ITEM_CATEGORIES":
      return {
        ...state,
        fetchedItem: false,
        loadingItem: false,
        deleted: false,
        item: {}
      }

    case "RESET_ITEMS_CATEGORIES":
      return {
        ...state,
        fetchedItems: false,
        loadingItems: false,
        deleted: false,
        items: [],
        error: null
      }
    default:
      return state;
  }
}